module.exports = __webpack_public_path__ + "img/new-wallet.5c688505.svg";